import React from "react";
import { TIMER_STATUS } from "../../constants";
import { useSelector } from "react-redux";
import {
    selectSetting,
    selectTimeCount,
    selectTimeCountEnded,
    selectTimerStatus
} from "../../sessionWatchSlice";

export const TimerStatus = () => {
    const timeCount = useSelector(selectTimeCount);
    const timeSpentSeconds = Math.floor(timeCount / 1000);
    const timerStatus = useSelector(selectTimerStatus);
    const timeCountEnded = useSelector(selectTimeCountEnded);
    const setting = useSelector(selectSetting);

    return (
        <p className="timer-status">
            {setting.length === 0
                ? "Waiting to start"
                : (timerStatus === TIMER_STATUS[0] && !timeCountEnded)
                    ? "Status: Ready for first start!"
                    : timerStatus === TIMER_STATUS[0]
                        ? "Status: Stopped"
                        : `Time started ${new Date(timeSpentSeconds * 1000).toLocaleTimeString()}`}
        </p>
    );
};
